import { render, staticRenderFns } from "./HealthCoursesComp.vue?vue&type=template&id=224b0fc2&scoped=true"
import script from "./HealthCoursesComp.vue?vue&type=script&lang=js"
export * from "./HealthCoursesComp.vue?vue&type=script&lang=js"
import style0 from "./HealthCoursesComp.vue?vue&type=style&index=0&id=224b0fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b0fc2",
  null
  
)

/* custom blocks */
import block0 from "./HealthCoursesComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports